import Vue from "vue";
import Router from "vue-router";
//import store from "./store";

import Layout from "./components/DefaultLayout.vue";

// DASHBOARD
import Dashboard from "./views/Dashboard/StudentDashboard.vue";
import SubagentDashboard from "./views/Dashboard/subagentdashboard.vue";
import StudentProfile from "./views/AdminMenus/studentProfile.vue";
import StudentRegistration from "./views/AdminMenus/studentRegistration.vue";
import StudentTrainingProcess from "./views/AdminMenus/studentTrainingProcess.vue";
import StudentApplicationProcess from "./views/AdminMenus/studentApplicationProcess.vue";
import StudentVisaProcess from "./views/AdminMenus/studentVisaProcess.vue";
import StudentUniversityRegistration from "./views/AdminMenus/studentUniversityRegistration.vue";
import AddLead from "./views/AdminMenus/addLead.vue";

// LOGIN
import Login from "./views/Login/Login.vue";
//import A2z from "./views/Login/a2z.vue";
import MainPage from "./views/Login/mainPage.vue";
import News from "./views/Login/news.vue";
import Allcountries from "./views/Login/allcountries.vue";
import NewsDetail from "./views/Login/newsDetail.vue";
import Home1 from "./views/Login/home1.vue";
import AboutUs from "./views/Login/aboutus.vue";
import Blog from "./views/Login/blog.vue";
import Contactus from "./views/Login/contactus.vue";
import BlogDetail from "./views/Login/blogDetail.vue";
import Testimonial from "./views/Login/testimonial.vue";
import Testpreparation from "./views/Login/testpreparation.vue";
import Testpreparation1 from "./views/Login/test-preparation.vue";
import Careercounselling from "./views/Login/careercounselling.vue";
import Meetcounsellor from "./views/Login/meetcounsellor.vue";
import University from "./views/Login/university.vue";
import CourseApplication from "./views/Login/application.vue";
import Travelvisa from "./views/Login/travelvisa.vue";
import Financial from "./views/Login/financial.vue";
import TestimonialList1 from "./views/Login/testimoniallist.vue";
import Countrydetail from "./views/Login/countrydetail.vue";
import studyinuk from "./views/Login/study-in-uk.vue";
import studyindubai from "./views/Login/study-in-dubai.vue";
import studyinsingapore from "./views/Login/study-in-singapore.vue";
import studyingermany from "./views/Login/study-in-germany.vue";
import studyineurope from "./views/Login/study-in-europe.vue";
import studyinnewzealand from "./views/Login/study-in-newzealand.vue";
import studyinfrance from "./views/Login/study-in-france.vue";
import studyinnetherlands from "./views/Login/study-in-netherlands.vue";
import studyinireland from "./views/Login/study-in-ireland.vue";


import studyinusa from "./views/Login/study-in-usa.vue";
import studyinaustralia from "./views/Login/study-in-australia.vue";
import Canadadetail from "./views/Login/canadadetail.vue";
import Galleries from "./views/Login/gallery.vue";


import TestDetail from "./views/Login/testDetail.vue";
import Team from "./views/Login/team.vue";
import List from "./views/Login/list.vue";
import ListChild from "./views/Login/listChild.vue";
import ViewCategoryList from "./views/Login/viewCategoryList.vue";
import CartList from "./views/Login/cartList.vue";
import WishList from "./views/Login/wishList.vue";
import Detail from "./views/Login/detail.vue";
import UploadPrescription from "./views/Login/uploadPrescription.vue";
import EnquiryDetail from "./views/Login/enquiryDetail.vue";
import EnquiryLists from "./views/Login/enquiryList.vue";
//import Home from "./views/Login/home.vue";
import HeaderFooter from "./views/Login/headerFooter.vue";
import Searchuniversity from "./views/Login/searchuniversity.vue";
import HeaderFooter1 from "./views/Login/headerFooter1.vue";
import VendorRegistration from "./views/Login/vendorRegistration.vue";
import Registration from "./views/Login/registration.vue";
import MyProfile from "./views/Login/myProfile.vue";
import CustomerAddress from "./views/Login/customerAddress.vue";
import MyOrders from "./views/Login/myOrder.vue";
import OrderDetail from "./views/Login/orderDetail.vue";
import ProductDetail from "./views/Login/productDetail.vue";
import Privacy from "./views/Login/privacy.vue";
import Cancellation from "./views/Login/cancellation.vue";
import Refund from "./views/Login/refuund.vue";
import Shipping from "./views/Login/shipping.vue";
import Terms from "./views/Login/terms.vue";
import Returns from "./views/Login/returns.vue";
import CategoryList from "./views/Login/categoryList.vue";
import Partners from "./views/Login/partners.vue";
import VendorRegister from "./views/Login/vendorRegister.vue";
import MyReview from "./views/Login/myReview.vue";
import VisionMission from "./views/Login/visionMission.vue";
import DirectorDesk from "./views/Login/directordesk.vue";
import Events from "./views/Login/event.vue";
import StudentLogin from "./views/Login/studentLogin.vue";
import SubAgentLogin from "./views/Login/subagentlogin.vue";
import UniversityDetails from "./views/Login/university-details.vue";


// Company
import Company from "./views/Company/company.vue";
import EditCompany from "./views/Company/editCompany.vue";

// USER
import User from "./views/Users/user.vue";
import EditUser from "./views/Users/editUser.vue";
import CreateUser from "./views/Users/createUser.vue";
// USER -> CHANGE PASSWORD
import ChangePassword from "./views/Users/changePassword.vue";
// USER -> EDIT USER PROFILE

//ItemCategory
import ItemCategory from "./views/ItemCategory/itemCategory.vue";
import CreateItemCategory from "./views/ItemCategory/createItemCategory.vue";
import EditItemCategory from "./views/ItemCategory/editItemCategory.vue";

//Item
import Item from "./views/Item/item.vue";
import CreateItem from "./views/Item/createItem.vue";
import EditItem from "./views/Item/editItem.vue";
import ItemImage from "./views/Item/itemImage.vue";


//Customer
import Customer from "./views/Customer/customer.vue";
import ViewCustomer from "./views/Customer/viewCustomer.vue";
import CreateCustomer from "./views/Customer/createCustomer.vue";

//Manufacturer
import Manufacturer from "./views/Manufacturer/manufacturer.vue";
import CreateManufacturer from "./views/Manufacturer/createManufacturer.vue";
import EditManufacturer from "./views/Manufacturer/editManufacturer.vue";

//MyOrder
import MyOrder from "./views/MyOrder/myOrder.vue";
import ViewOrder from "./views/MyOrder/viewOrder.vue";

//MyQuotation
import MyQuotation from "./views/Quotation/myQuotation.vue";
import ViewQuotation from "./views/Quotation/viewQuotation.vue";
import EditQuotation from "./views/Quotation/editQuotation.vue";

//Enquiry
import EnquiryList from "./views/Enquiry/enquiryList.vue";
import ViewEnquiry from "./views/Enquiry/viewEnquiry.vue";

//MyProfile
import CustomerProfile from "./views/MyProfile/customerProfile.vue";
import VendorProfile from "./views/MyProfile/vendorProfile.vue";
import EditCustomer from "./views/MyProfile/editCustomer.vue";

//AddressBook
import AddressBook from "./views/AddressBook/addressBook.vue";
import CreateAddressBook from "./views/AddressBook/createAddressBook.vue";
import EditAddressBook from "./views/AddressBook/editAddressBook.vue";

import Product from "./views/Product/product.vue";
import CreateProduct from "./views/Product/createProduct.vue";
import EditProduct from "./views/Product/editProduct.vue";
import Gallery from "./views/Product/gallery.vue";

//HsnCode
import HsnCode from "./views/HsnCode/hsnCode.vue";
import CreateHsnCode from "./views/HsnCode/createHsnCode.vue";
import EditHsnCode from "./views/HsnCode/editHsnCode.vue";

//UOM
import Uom from "./views/UOM/uom.vue";
import CreateUom from "./views/UOM/createUom.vue";
import EditUom from "./views/UOM/editUom.vue";

//VENDOR
import Vendor from "./views/Vendor/vendor.vue";
import CreateVendor from "./views/Vendor/createVendor.vue";
import EditVendor from "./views/Vendor/editVendor.vue";

//PURCHASEORDER
import PurchaseOrder from "./views/PurchaseOrder/purchaseOrder.vue";
import CreatePurchaseOrder from "./views/PurchaseOrder/createPurchaseOrder.vue";
import EditPurchaseOrder from "./views/PurchaseOrder/editPurchaseOrder.vue";

//GRN
import Grn from "./views/GRN/grn.vue";
import CreateGrn from "./views/GRN/createGrn.vue";
import EditGrn from "./views/GRN/editGrn.vue";

//INVOICE
import Invoice from "./views/Invoice/invoice.vue";
import CreateInvoice from "./views/Invoice/createInvoice.vue";
import EditInvoice from "./views/Invoice/editInvoice.vue";

//SalesOrder
import SalesOrder from "./views/SalesOrder/salesOrder.vue";
import ViewSalesOrder from "./views/SalesOrder/viewSalesOrder.vue";
import Prescription from "./views/SalesOrder/prescription.vue";

//Report
import StockSummary from "./views/Reports/stockSummary.vue";
import Enquiry from "./views/Reports/enquiry.vue";

//Notification
import Notification from "./views/Notification/notification.vue";

//Testimonial
import Testimonials from "./views/Testimonial/testimonial.vue";
import CreateTestimonial from "./views/Testimonial/createTestimonial.vue";
import EditTestimonial from "./views/Testimonial/editTestimonial.vue";

import Comments from "./views/Comment/comment.vue";
import ViewComment from "./views/Comment/viewComment.vue";
import CreateComment from "./views/Comment/createComment.vue";
import AddDocument from "./views/MyProfile/addDocument.vue";
Vue.use(Router);

function guardMyroute(to, from, next)
{
 var isAuthenticated= false;
//this is just an example. You will have to find a better or 
// centralised way to handle you localstorage data handling 
if(sessionStorage.getItem('loggedInUserID') != null)
  isAuthenticated = true;
 else
  isAuthenticated= false;
 if(isAuthenticated) 
 {
  next(); // allow to enter route
 } 
 else
 {
  next('/login');  // go to '/login';
 }
}

const router = new Router({

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /* {
      path: "",
      redirect: "/csquad",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/csquad",
      component: MainPage,
      meta: {
        transitionName: 'slide'
      }
    }, */
    {
      path: "",
      component: HeaderFooter,
      children: [
        {
          path: "",
          redirect: "/login",
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "/worldwin",
          name: "MainPage",
          component: MainPage,
          meta: {
            title: 'Abroad education consultants | Study in Canada Call Us +91 9830989168',
            description: 'Achieve your dream of studying in Canada with the help of our trusted abroad education consultants. Call us at +91 9830989168 for expert guidance and personalized assistance throughout the application process. Unlock endless opportunities for growth and success with a world-class education in Canada.',
            keywords: 'Abroad education consultants, Study in Canada',
            requiresAuth: true
          }
        },
        {
          path: "/aboutus",
          name: "Aboutus",
          component: AboutUs,
          meta: {
            title: 'About-us',
            description: '',
            keywords: '',
            requiresAuth: true
          }
        },
        {
          path: "/visionMission",
          name: "VisionMission",
          component: VisionMission,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/directorDesk",
          name: "DirectorDesk",
          component: DirectorDesk,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/event",
          name: "Event",
          component: Events,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "/blog",
          name: "Blog",
          component: Blog,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/testimonial-list",
          name: "TestimonialList1",
          component: TestimonialList1,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/news",
          name: "News",
          component: News,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/gallery",
          name: "gallery",
          component: Galleries,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/university",
          name: "University",
          component: University,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/search-university",
          name: "Searchuniversity",
          component: Searchuniversity,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/countrydetail/:id",
          name: "Countrydetail",
          component: Countrydetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-uk",
          name: "study-in-uk",
          component: studyinuk,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-dubai",
          name: "study-in-dubai",
          component: studyindubai,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-singapore",
          name: "study-in-singapore",
          component: studyinsingapore,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-germany",
          name: "study-in-germany",
          component: studyingermany,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-europe",
          name: "study-in-europe",
          component: studyineurope,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-newzealand",
          name: "study-in-newzealand",
          component: studyinnewzealand,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-france",
          name: "study-in-france",
          component: studyinfrance,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-netherlands",
          name: "study-in-netherlands",
          component: studyinnetherlands,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-ireland",
          name: "study-in-ireland",
          component: studyinireland,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/study-in-usa",
          name: "study-in-usa",
          component: studyinusa,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/university-details",
          name: "UniversityDetails",
          component: UniversityDetails,
          meta: {
            requiresAuth: true
          }
        },
        
        {
          path: "/study-in-canada",
          name: "Canadadetail",
          component: Canadadetail,
          meta: { 
            title: 'Study in Canada as International Student: Colleges, Scholarships, Fees',
            description: 'Unlock endless opportunities for international students to study in Canada. Explore top colleges, scholarships, and affordable fees to make your dream of studying abroad a reality. Discover a world-class education system in a diverse and welcoming country. Start your journey today!',
            keywords: 'Study in Canada, Foreign education consultants in kolkata',
            requiresAuth: true
          }
        },
        {
          path: "/study-in-australia",
          name: "study-in-australia",
          component: studyinaustralia,
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: "/newsDetail/:id",
          name: "NewsDetail",
          component: NewsDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/blogDetail/:id",
          name: "BlogDetail",
          component: BlogDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/test-preparation",
          name: "TestPreparation",
          component: Testpreparation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/test-preparation1",
          name: "TestPreparation1",
          component: Testpreparation1,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/all-countries",
          name: "Allcountries",
          component: Allcountries,
          meta: {
            title: 'Best Study overseas consultants in Kolkata | Aboard Educational Consultant',
            description: 'Looking to study abroad? Look no further! Aboard Educational Consultant in Kolkata is your go-to destination for all your study overseas needs. We offer expert guidance, personalized counseling, and a wide range of services to help you make the best decision for your future. Contact us today and let us help you turn your dreams into reality.',
            keywords: 'study overseas consultants, best study abroad consultants, study abroad consultants in kolkata, overseas education consultants in kolkata',
            requiresAuth: true
          }
        },
        {
          path: "/career-counselling",
          name: "Careercounselling",
          component: Careercounselling,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/course-application",
          name: "Courseapplication",
          component: CourseApplication,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/travel-visa-forex",
          name: "Travelvisa",
          component: Travelvisa,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/test-preparation-detail/:id",
          name: "TestDetail",
          component: TestDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/financial-assistance",
          name: "Financial",
          component: Financial,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/partners",
          name: "Partners",
          component: Partners,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/categoryList",
          name: "CategoryList",
          component: CategoryList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/testimonial",
          name: "Testimonial",
          component: Testimonial,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/contactus",
          name: "Contactus",
          component: Contactus,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/meet-counsellor",
          name: "Meetcounsellor",
          component: Meetcounsellor,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/team",
          name: "Team",
          component: Team,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/myProfile",
          name: "MyProfile",
          component: MyProfile,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/customerAddress/:id",
          name: "CustomerAddress",
          component: CustomerAddress,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/myOrder",
          name: "MyOrder",
          component: MyOrders,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/orderDetail/:id",
          name: "OrderDetail",
          component: OrderDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/productDetail/:id",
          name: "productDetail",
          component: ProductDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/cartList",
          name: "CartList",
          component: CartList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/wishList",
          name: "WishList",
          component: WishList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/myReview",
          name: "MyReview",
          component: MyReview,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/privacy",
          name: "Privacy",
          component: Privacy,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/terms",
          name: "Terms",
          component: Terms,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/returns",
          name: "Returns",
          component: Returns,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/cancellation",
          name: "Cancellation",
          component: Cancellation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/refund",
          name: "Refund",
          component: Refund,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/shipping",
          name: "Shipping",
          component: Shipping,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/detail",
          name: "Detail",
          component: Detail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/uploadPrescription",
          name: "UploadPrescription",
          component: UploadPrescription,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/viewCategoryList",
          name: "ViewCategoryList",
          component: ViewCategoryList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/enquiryDetail/:id",
          name: "EnquiryDetail",
          component: EnquiryDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/enquirylists",
          name: "EnquiryLists",
          component: EnquiryLists,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/list",
          name: "list",
          component: List,
          children: [
            {
              path: "",
              redirect: "/listChild",
              meta: {
                requiresAuth: true,
                transitionName: "slide"
              }
            },
            {
              path: "/listChild",
              name: "listChild",
              component: ListChild,
              meta: {
                requiresAuth: true,
                transitionName: "slide"
              }
            },
          ]
        }
      ]
    },
    {
      path: "/",
      component: HeaderFooter1,
      children: [
        {
          path: "",
          redirect: "/csquad1",
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/csquad1",
          name: "Home1",
          component: Home1,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/aboutus",
          name: "Aboutus",
          component: AboutUs,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/blog",
          name: "Blog",
          component: Blog,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/partners",
          name: "Partners",
          component: Partners,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/categoryList",
          name: "CategoryList",
          component: CategoryList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/testimonial",
          name: "Testimonial",
          component: Testimonial,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/team",
          name: "Team",
          component: Team,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/myProfile",
          name: "MyProfile",
          component: MyProfile,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/customerAddress/:id",
          name: "CustomerAddress",
          component: CustomerAddress,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/myOrder",
          name: "MyOrder",
          component: MyOrders,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/orderDetail/:id",
          name: "OrderDetail",
          component: OrderDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/productDetail/:id",
          name: "productDetail",
          component: ProductDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/cartList",
          name: "CartList",
          component: CartList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/wishList",
          name: "WishList",
          component: WishList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/myReview",
          name: "MyReview",
          component: MyReview,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/privacy",
          name: "Privacy",
          component: Privacy,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/terms",
          name: "Terms",
          component: Terms,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/returns",
          name: "Returns",
          component: Returns,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/cancellation",
          name: "Cancellation",
          component: Cancellation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/refund",
          name: "Refund",
          component: Refund,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/shipping",
          name: "Shipping",
          component: Shipping,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/detail",
          name: "Detail",
          component: Detail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/uploadPrescription",
          name: "UploadPrescription",
          component: UploadPrescription,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/viewCategoryList",
          name: "ViewCategoryList",
          component: ViewCategoryList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/enquiryDetail/:id",
          name: "EnquiryDetail",
          component: EnquiryDetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/enquirylists",
          name: "EnquiryLists",
          component: EnquiryLists,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/list",
          name: "list",
          component: List,
          children: [
            {
              path: "",
              redirect: "/listChild",
              meta: {
                requiresAuth: true,
                transitionName: "slide"
              }
            },
            {
              path: "/listChild",
              name: "listChild",
              component: ListChild,
              meta: {
                requiresAuth: true,
                transitionName: "slide"
              }
            },
          ]
        }
      ]
    },
    {
      path: "/login",
      component: Login,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/studentlogin",
      component:StudentLogin,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/subagentlogin",
      component:SubAgentLogin,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/vendorRegister",
      component: VendorRegister,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/vendorRegistration",
      component: VendorRegistration,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/registration",
      component: Registration,
      meta: {
        transitionName: 'slide'
      }
    },
    
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/dashboard",
          component: Dashboard,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/subagent-dashboard",
          component: SubagentDashboard,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/studentProfile",
          component: StudentProfile,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/studentRegistration",
          component: StudentRegistration,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/studentTrainingProcess",
          component: StudentTrainingProcess,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/studentApplicationProcess",
          component: StudentApplicationProcess,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/studentVisaProcess",
          component: StudentVisaProcess,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/studentUniversityRegistration",
          component: StudentUniversityRegistration,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/addLead",
          component: AddLead,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        // COMPANY
        {
          path: "/company",
          component: Company,
          beforeEnter : guardMyroute,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editCompany/:id",
          beforeEnter : guardMyroute,
          component: EditCompany,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        
        // USER
        {
          path: "/users",
          beforeEnter : guardMyroute,
          component: User,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createUser",
          beforeEnter : guardMyroute,
          component: CreateUser,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editUser/:id",
          beforeEnter : guardMyroute,
          component: EditUser,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/changePassword/:id",
          beforeEnter : guardMyroute,
          component: ChangePassword,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // ItemCategory
        {
          path: "/itemCategory",
          beforeEnter : guardMyroute,
          component: ItemCategory,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/createItemCategory",
          beforeEnter : guardMyroute,
          component: CreateItemCategory,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editItemCategory/:id",
          beforeEnter : guardMyroute,
          component: EditItemCategory,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // HSNCODE
        {
          path: "/hsnCode",
          beforeEnter : guardMyroute,
          component: HsnCode,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createHsnCode",
          beforeEnter : guardMyroute,
          component: CreateHsnCode,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editHsnCode/:id",
          beforeEnter : guardMyroute,
          component: EditHsnCode,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // UOM
        {
          path: "/uom",
          beforeEnter : guardMyroute,
          component: Uom,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createUom",
          beforeEnter : guardMyroute,
          component: CreateUom,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editUom/:id",
          beforeEnter : guardMyroute,
          component: EditUom,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // Item
        {
          path: "/item",
          beforeEnter : guardMyroute,
          component: Item,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/createItem",
          beforeEnter : guardMyroute,
          component: CreateItem,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editItem/:id",
          beforeEnter : guardMyroute,
          component: EditItem,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/itemImage/:id",
          beforeEnter : guardMyroute,
          component: ItemImage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // VENDOR
        {
          path: "/vendor",
          beforeEnter : guardMyroute,
          component: Vendor,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createVendor",
          beforeEnter : guardMyroute,
          component: CreateVendor,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editVendor/:id",
          beforeEnter : guardMyroute,
          component: EditVendor,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // PURCHASEORDER
        {
          path: "/purchaseOrder",
          beforeEnter : guardMyroute,
          component: PurchaseOrder,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createPurchaseOrder",
          beforeEnter : guardMyroute,
          component: CreatePurchaseOrder,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editPurchaseOrder/:id",
          beforeEnter : guardMyroute,
          component: EditPurchaseOrder,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // GRN
        {
          path: "/grn",
          beforeEnter : guardMyroute,
          component: Grn,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createGrn",
          beforeEnter : guardMyroute,
          component: CreateGrn,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editGrn/:id",
          beforeEnter : guardMyroute,
          component: EditGrn,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // INVOICE
        {
          path: "/invoice",
          beforeEnter : guardMyroute,
          component: Invoice,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createInvoice",
          beforeEnter : guardMyroute,
          component: CreateInvoice,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editInvoice/:id",
          beforeEnter : guardMyroute,
          component: EditInvoice,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/salesOrder",
          beforeEnter : guardMyroute,
          component: SalesOrder,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewSalesOrder/:id",
          beforeEnter : guardMyroute,
          component: ViewSalesOrder,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/prescription/:id",
          beforeEnter : guardMyroute,
          component: Prescription,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/comment",
          beforeEnter : guardMyroute,
          component: Comments,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createComment/:id",
          beforeEnter : guardMyroute,
          component: CreateComment,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewComment/:id",
          beforeEnter : guardMyroute,
          component: ViewComment,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // Product
        {
          path: "/product",
          beforeEnter : guardMyroute,
          component: Product,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/createProduct",
          beforeEnter : guardMyroute,
          component: CreateProduct,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editProduct/:id",
          beforeEnter : guardMyroute,
          component: EditProduct,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/gallery/:id",
          beforeEnter : guardMyroute,
          component: Gallery,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        //Customer
        {
          path: "/customer",
          beforeEnter : guardMyroute,
          component: Customer,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/createCustomer",
          beforeEnter : guardMyroute,
          component: CreateCustomer,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewCustomer/:id",
          beforeEnter : guardMyroute,
          component: ViewCustomer,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // Manufacturer
        {
          path: "/manufacturer",
          beforeEnter : guardMyroute,
          component: Manufacturer,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/createManufacturer",
          beforeEnter : guardMyroute,
          component: CreateManufacturer,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editManufacturer/:id",
          beforeEnter : guardMyroute,
          component: EditManufacturer,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        //MyOrder
        {
          path: "/myOrder",
          beforeEnter : guardMyroute,
          component: MyOrder,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/viewOrder/:id",
          beforeEnter : guardMyroute,
          component: ViewOrder,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/stockSummary",
          beforeEnter : guardMyroute,
          component: StockSummary,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/enquiry",
          beforeEnter : guardMyroute,
          component: Enquiry,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        //MyQuotation
        {
          path: "/myQuotation",
          beforeEnter : guardMyroute,
          component: MyQuotation,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/viewQuotation/:id",
          beforeEnter : guardMyroute,
          component: ViewQuotation,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editQuotation/:id",
          beforeEnter : guardMyroute,
          component: EditQuotation,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        //Enquiry
        {
          path: "/enquiryList",
          beforeEnter : guardMyroute,
          component: EnquiryList,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/viewEnquiry/:id",
          beforeEnter : guardMyroute,
          component: ViewEnquiry,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        //MyProfile
        {
          path: "/customerProfile",
          beforeEnter : guardMyroute,
          component: CustomerProfile,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/vendorProfile",
          beforeEnter : guardMyroute,
          component: VendorProfile,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editCustomer/:id",
          beforeEnter : guardMyroute,
          component: EditCustomer,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        //AddressBook
        {
          path: "/addressBook",
          beforeEnter : guardMyroute,
          component: AddressBook,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/createAddressBook",
          beforeEnter : guardMyroute,
          component: CreateAddressBook,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editAddressBook/:id",
          beforeEnter : guardMyroute,
          component: EditAddressBook,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/notification",
          beforeEnter : guardMyroute,
          component: Notification,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        // TESTIMONIAL
        {
          path: "/testimonials",
          beforeEnter : guardMyroute,
          component: Testimonials,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createTestimonial",
          beforeEnter : guardMyroute,
          component: CreateTestimonial,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editTestimonial/:id",
          beforeEnter : guardMyroute,
          component: EditTestimonial,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/addDocument",
          name: "AddDocument",
          component: AddDocument,
          meta: {
            requiresAuth: true
          }
        },
      ]
    }
  ],
});
/* const DEFAULT_TITLE = 'Some Default Title';
const DEFAULT_DESCRIPTION = 'Some Default Description';
const DEFAULT_KEYWORDS = 'Some Default Keywords';
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
        document.description = to.meta.description || DEFAULT_DESCRIPTION;
        document.keywords = to.meta.keywords || DEFAULT_KEYWORDS
    });
}); */

export default router;
